import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-footer",
  template: `
    <div class="layout-footer">
      <div class="content-section layout-footer clearfix">
        <span
          >&copy; 2017-{{ today | date: "yyyy" }} Children's Hospital Assn. &amp;
          <a
            href="https://www.childrenshospitals.org/Programs-and-Services/Pediatric-Learning-Solutions"
            target="_blank"
            rel="noopener noreferrer"
            >Pediatric Learning Solutions</a
          ></span
        >
        <div class="footer-links"></div>
      </div>
    </div>
  `
})
export class AppFooterComponent implements OnInit {
  today = new Date();

  constructor() { }

  ngOnInit(): void {
    this.today.getFullYear(); // Populate Footer Message
  }
}
